import { RouteConfig } from 'vue-router';

import Fees from '@/views/fee/List.vue';

export function feesRoute(name: string): RouteConfig {
  return {
    path: '',
    name,
    component: Fees,
    meta: {}
  };
}
